import React from 'react';
import { Box } from '@mui/material';
import S3ImageUploader from '../S3ImageUploader';

const S3UploadTab = () => (
  <Box sx={{ mt: { xs: 1, sm: 2, md: 4 } }}>
    <S3ImageUploader />
  </Box>
);

export default S3UploadTab;
